export default __webpack_public_path__ + "static/media/search.0faebb09.svg";